/**
 * @param tableElement {Element}
 *
 * @returns {[]}
 */
function getTableRows(tableElement) {
    const myRows = [];
    if (typeof tableElement === 'object' && tableElement.nodeType === 1) {
        tableElement.querySelectorAll('tbody tr').forEach((tableRow, index) => {
            myRows[index] = [];
            tableRow.querySelectorAll('td').forEach((cell, cellIndex) => {
                myRows[index][cellIndex] = { value: cell.innerHTML, backgroundColor: cell.style.backgroundColor };
            });
        });
    }

    return myRows;
}

/**
 * @param tableElement {Element}
 *
 * @returns {[]}
 */
function getTableColumns(tableElement) {
    const tableHeaders = [];
    if (typeof tableElement === 'object' && tableElement.nodeType === 1) {
        tableElement.querySelectorAll('th').forEach((th) => {
            tableHeaders.push({
                name: th.innerHTML,
                html: true,
            });
        });
    }

    return tableHeaders;
}

export { getTableRows, getTableColumns };
